// utils/compareState.js
import { ref } from "vue";

const COMPARE_KEY = "compareCars";
const compareCars = ref([]);

// Load from localStorage once on startup
if (typeof window !== "undefined") {
  const saved = localStorage.getItem(COMPARE_KEY);
  compareCars.value = saved ? JSON.parse(saved) : [];
}

export const getCompareCars = () => compareCars;

export const isInCompare = (carId) => {
  return compareCars.value.some((car) => car.id === carId);
};

export const toggleCompare = (car) => {
  const index = compareCars.value.findIndex((c) => c.id === car.id);

  if (index === -1) {
    if (Object.keys(car).length > 1) {
      if (compareCars.value.length >= 3) {
        // remove oldest
        compareCars.value.shift();
      }
      compareCars.value.push(car);
    }
  } else {
    // remove if already in
    compareCars.value.splice(index, 1);
  }

  localStorage.setItem(COMPARE_KEY, JSON.stringify(compareCars.value));
  return compareCars.value;
};

export const clearCompare = () => {
  compareCars.value = [];
  localStorage.removeItem(COMPARE_KEY);
  return compareCars.value;
};
